import {
  Avatar,
  AvatarBadge,
  Box,
  Card,
  CardBody,
  Flex,
  Heading,
  Icon,
  Stack,
  StackDivider,
  Text,
  IconButton,
  HStack,
} from "@chakra-ui/react";
import { AiOutlineArrowLeft } from "react-icons/ai";

import { useRouter } from "../../utils/useRouter";
import { UserService } from "../../services/UserService";

interface TextBlockProps {
  label: string;
  value: string;
}

function TextBlock({ label, value }: TextBlockProps) {
  return (
    <Stack direction="column">
      <Heading as="h4" fontSize="14px" fontWeight="500">
        {label}
      </Heading>
      <Text fontSize="16px">{value || "-"}</Text>
    </Stack>
  );
}

export function Profile() {
  const { navigate } = useRouter();
  const profile = UserService.getProfile();

  const onPrevious = () => {
    navigate(-1);
  };

  return (
    <Box px={4} py={8} w="50%">
      <Flex direction="column" gap={2}>
        <HStack direction="row">
          <IconButton
            icon={
              <Icon as={AiOutlineArrowLeft as React.ElementType} w={6} h={6} />
            }
            aria-label="back"
            onClick={onPrevious}
            variant="ghost"
          />
          <Heading as="h2" fontSize="24px">
            Your profile
          </Heading>
        </HStack>
        <Card p={4}>
          <CardBody>
            {profile !== null && (
              <Stack divider={<StackDivider color="gray.200" />} spacing={4}>
                <Flex
                  direction="row"
                  justifyContent="space-between"
                  alignItems="flex-start"
                >
                  <Stack direction="row" spacing={8}>
                    <Avatar>
                      <AvatarBadge boxSize="1.25em" bg="green.500" />
                    </Avatar>
                    <Stack direction="column" spacing={2}>
                      <Heading as="h3" fontSize="20px" fontWeight="600">
                        {profile.name}
                      </Heading>
                      <Text fontSize="12px">{profile.role}</Text>
                    </Stack>
                  </Stack>
                  {/* <Button
                    bgColor="transparent"
                    _hover={{ bgColor: "transparent" }}
                    _active={{ bgColor: "transparent" }}
                    leftIcon={<AiOutlineEdit />}
                    size="sm"
                    textColor="brand.700"
                  >
                    Edit
                  </Button> */}
                </Flex>
                <Stack direction="column" py={4} w="100%">
                  <Flex direction="row" justifyContent="space-between">
                    <TextBlock label="Email ID" value={profile.email} />
                    <TextBlock label="Phone Number" value={profile.phone} />
                  </Flex>
                </Stack>
              </Stack>
            )}
          </CardBody>
        </Card>
      </Flex>
    </Box>
  );
}
